// Import necessary libraries and modules
import axios from 'axios';

// Make certain variables available globally
window.$ = window.jQuery = require('jquery');
window.autocomplete = require('devbridge-autocomplete');
window.lazysizes = require('lazysizes');
window.select2 = require('select2');

// Configure toastr for flash messages
window.toastr = require('toastr');
window.toastr.options.closeButton = true;
window.toastr.options.closeMethod = 'fadeOut';
window.toastr.options.preventDuplicates = true;
window.toastr.options.progressBar = true;
window.toastr.options.closeHtml = '<button><i class="fa-solid fa-xmark fa-2xs"></i></button>';

// Configure axios for HTTP requests
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
window.axios.defaults.headers.common['Accept-Language'] = $('html').attr('lang');
// Load additional scripts
require('./components/category-subnav');
require('./components/dropdown');
require('./components/errors');
require('./components/filter');
require('./components/filter-mobile');
require('./components/header');
require('./components/helpers');
require('./components/loader');
require('./components/mobilenav');
require('./components/modals');
require('./components/select2');
require('./components/slick');
require('./components/subnav');
require('./components/tabs');
require('./components/ga-events');
require('default-passive-events');

// Load the Vue.js components.
require('./vue');